import React, { Component } from 'react'
// import { hot } from 'react-hot-loader/root';
import {
  HashRouter as Router,
  Route,
  Switch,
  withRouter,
} from 'react-router-dom'
import { getRouterData } from './web'
import _ from 'lodash'
import { notification, Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import qs from 'query-string'
import { API_HOST } from '../configs/env'
import whttp from '../libs/whttp'
import './styles.module.scss'
import AppHelper from '../libs/AppHelper'
import history from '../libs/history'
import NotificationCenter, {
  NotificationName,
} from '../libs/NotificationCenter'
import { wConnectRedux } from '../reducers'
import { LOGIN_LINK } from '../configs/env'
import { __ } from '@wordpress/i18n'

const VC_CONFIG = _.get(window, 'VC_CONFIG', {})
const oca_login_url = _.get(this.props, 'app.configs.oca_login_url')
const isLogin = _.get(this, 'props.auth.isLogin')

//const _ = __
class Login extends Component {
  state = {
    LoginUrl: null,
  }
  componentDidMount() {
    const { auth, user } = this.props

    if (auth && auth.isLogin && user == null) {
      AppHelper.updateUserInfo()
    }
    // auth異動
    this.authDeniedToken = NotificationCenter.default.addObserver(
      this,
      (notif) => {
        this.props.cleanUserInfo && this.props.cleanUserInfo()
        this.props.cleanAuthInfo && this.props.cleanAuthInfo()
        AppHelper.removeLocalStorage('to-href')
        // notification['warning']({message:'請重新登入', duration: 1, onClose:() => {
        //   this.GetOcaUri();
        //   if(this.state.LoginUrl) window.location.href = this.state.LoginUrl;
        // }})

        if (oca_login_url) {
          Modal.confirm({
            title: '登入資訊過期，請重新登入',
            cancelText: '返回首頁',
            okText: '立即登入',
            onCancel: () => {
              window.location.replace(VC_CONFIG.INDEX_URL)
            },
            onOk: () => {
              // ALVIN 2023/05/05 Remark OCA Login
              // this.GetOcaUri();
              // ALVIN 2023/05/17 Updated
              this.GetCCUri()
              if (this.state.LoginUrl)
                window.location.replace(this.state.LoginUrl)
            },
          })
        } else if (!isLogin) {
          // ALVIN 2023/05/05 Remark OCA Login
          // this.GetOcaUri();
          this.GetCCUri()
          if (this.state.LoginUrl) window.location.replace(this.state.LoginUrl)
        } else {
          Modal.error({
            title: '登入資訊過期，請重新登入',
            okText: '返回首頁',
            onOk: () => {
              // this.GetOcaUri();
              window.location.replace(VC_CONFIG.INDEX_URL)
              // if(this.state.LoginUrl) window.location.replace(VC_CONFIG.INDEX_URL);
            },
          })
        }
      },
      NotificationName.AuthDenied
    )

    // // auth異常
    // this.authDeniedToken = NotificationCenter.default.addObserver(this, (notification) => {
    //   console.log('PermissionsDidChanged', notification)
    //   this.forceUpdate()
    // }, NotificationName.PermissionsDidChanged)
  }

  componentWillUnmount() {
    //NotificationCenter.default.removeObserver(this)
  }

  // ALVIN 2023/05/05 調整為CC登入
  GetCCUri = () => {
    this.setState({ isSubmitData: true })
    whttp.get(API_HOST + `/api/account/cc/login`, {}, (state, res) => {
      console.log(state, res)

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res

      if (state === false) {
        this.setState({ isSubmitData: false })
        return notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
      }

      if (code !== 200) {
        this.setState({ isSubmitData: false })
        notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          description: reason,
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
        return
      }
      console.log(code, reason, data, res)

      // 修改成直接過去CC
      // this.GoCCLoginPage(data.uri)
      this.setState({ isSubmitData: false })
      this.setState({ LoginUrl: data.uri })
      window.location.href = data.uri
    })
  }

  // 2023/05/05 取得並前往 CC Login Url
  GoCCLoginPage = (ccApiUrl) => {
    whttp.get(ccApiUrl, {}, (state, res) => {
      console.log(state, res)
      this.setState({ isSubmitData: false })

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res
      if (state === false) {
        return notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
      }
      if (code !== 200) {
        notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          description: reason,
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
        return
      }
      console.log(code, reason, data, res)
      this.setState({ LoginUrl: data.uri })
      window.location.href = data.uri
    })
  }

  GetOcaUri = () => {
    this.setState({ isSubmitData: true })
    whttp.get(API_HOST + `/api/account/oca/login`, {}, (state, res) => {
      console.log(state, res)
      this.setState({ isSubmitData: false })

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res

      if (state === false) {
        return notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
      }

      if (code !== 200) {
        notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          description: reason,
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
        return
      }
      console.log(code, reason, data, res)
      this.setState({ LoginUrl: data.uri })
      window.location.href = data.uri
    })
  }

  CCLogout = () => {
    this.setState({ isSubmitData: true })
    whttp.get(
      API_HOST + `/api/account/cc/ccUri?type=logout`,
      {},
      (state, res) => {
        const {
          code = 100,
          reason = __('發生錯誤', 'cec-plugin-stores'),
          data = {},
        } = res

        if (state === false) {
          this.setState({ isSubmitData: false })
          return notification['error']({
            message: __('發生錯誤', 'cec-plugin-stores'),
          })
        }
        if (code !== 200) {
          this.setState({ isSubmitData: false })
          notification['error']({
            message: __('發生錯誤', 'cec-plugin-stores'),
            description: reason,
          })
          return
        }

        console.log(data)
        this.CCLogoutProcess(data.uri)
      }
    )
  }

  CCLogoutProcess = (uri) => {
    // call cc logout api
    whttp.get(uri, {}, (state, res) => {
      this.setState({ isSubmitData: false })

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res

      if (state === false) {
        return notification['error']({
          message: __('發生錯誤', 'cec-plugin-stores'),
        })
      }
      if (code !== '200') {
        this.setState({ isSubmitData: false })
        notification['error']({
          message: __('發生錯誤', 'cec-plugin-stores'),
          description: reason,
        })
        return
      }

      console.log(data)
      AppHelper.removeLocalStorage('contact-data')
      AppHelper.removeLocalStorage('to-href')
      this.props.cleanUserInfo()
      this.props.cleanAuthInfo()

      notification['warning']({
        message: __('已成功登出', 'cec-plugin-stores'),
        duration: 1,
        onClose: () => {
          window.location.href = VC_CONFIG.INDEX_URL
        },
      })
    })
  }

  Logout = () => {
    this.setState({ isSubmitData: true })
    whttp.get(
      API_HOST + `/api/account/oca/ocaUri?type=logout`,
      {},
      (state, res) => {
        this.setState({ isSubmitData: false })

        const {
          code = 100,
          reason = __('發生錯誤', 'cec-plugin-stores'),
          data = {},
        } = res

        if (state === false) {
          return notification['error']({
            message: __('發生錯誤', 'cec-plugin-stores'),
          })
        }
        if (code !== 200) {
          notification['error']({
            message: __('發生錯誤', 'cec-plugin-stores'),
            description: reason,
          })
          return
        }

        console.log(data)
        //window.location.href = data.uri;
        AppHelper.removeLocalStorage('contact-data')
        AppHelper.removeLocalStorage('to-href')
        this.props.cleanUserInfo()
        this.props.cleanAuthInfo()
        // notification['warning']({message:__('已成功登出','cec-plugin-stores'), duration: 1, onClose:() => {
        //   window.location.href = VC_CONFIG.INDEX_URL;
        // }})
        window.location.href = data.uri
      }
    )
  }
  render() {
    const { auth } = this.props
    const user = _.get(this, 'props.user')
    const roles = _.get(this, 'props.user.roles', [])

    // 此處可簡單處理轉導功能
    // if (user.isLogin === false && window.location.pathname !== '/')
    //   history.replace('/')
    //console.log(user);
    const search = _.get(window, 'location.search')

    const queryParams = qs.parse(search)

    const slug = _.get(queryParams, 'page')
    const { Logoutconfirm } = Modal
    // 此處不使用Route原本Path的功能
    // 改看wp-admin/admin.php?page=stores
    return (
      <div class='loginButton'>
        {
          //UAT : https://toaccount.uni-prosperity.com.tw/C4TDMC/oauth/v2/authorization?response_type=code&client_id=b8f848827a0667870c436cca772b66a6&redirect_uri=https://cec.syscom.tw/service/sso/&state=C4&scope=read&device=1
          //模擬正式站: https://oaccount.uni-prosperity.com.tw/C4TDMC/oauth/v2/authorization?response_type=code&client_id=0e983ccd1d6257beb6e6619c4c6bd9c8&redirect_uri=${VC_CONFIG.INDEX_URL}/sso/&state=C4&scope=read&device=1
          // 正式站: https://oaccount.uni-prosperity.com.tw/C4TDMC/oauth/v2/authorization?response_type=code&client_id=c1fcb8f98958affb774975b45e9f8df4&redirect_uri=${VC_CONFIG.INDEX_URL}/sso/&state=C4&scope=read&device=1
          //console.log('domain: ',window.location.host)
        }
        {auth && auth.isLogin ? (
          <div class='d-flex'>
            <a
              class='text-primary'
              role='button'
              href={`${VC_CONFIG.INDEX_URL}/profile`}>
              {__('會員中心', 'cec-plugin-stores')}
            </a>
            <a
              class='text-primary ml-3 pl-3 border-left border-gray'
              role='button'
              href='#'
              onClick={() => {
                const { confirm } = Modal
                confirm({
                  title: __('是否要登出?', 'cec-plugin-stores'),
                  icon: <ExclamationCircleOutlined />,
                  onOk: () => {
                    // 走CC Logout
                    // this.Logout()
                    this.CCLogout()
                  },
                  onCancel() {},
                })
              }}>
              {__('登出', 'cec-plugin-stores')}
            </a>
          </div>
        ) : (
          <a
            class='btn btn-outline-primary rounded-pill'
            role='button'
            href='#'
            onClick={() => {
              // ALVIN 2023/05/05 Remark OCA Login
              // this.GetOcaUri();
              this.GetCCUri()
            }}>
            {__('登入/註冊', 'cec-plugin-stores')}
          </a>
        )}
      </div>
    )
  }
}

export default wConnectRedux(Login)

// export default process.env.NODE_ENV === "development" ? hot(wConnectRedux(App)) : wConnectRedux(App)



// WEBPACK FOOTER //
// ./src/routes/Login.js